// extracted by mini-css-extract-plugin
export var container = "ProductPageContainer-module--container--aqsKK";